/**
 * Allow scrolling dragging with the mouse even on desktop.
 * @param {DOM node} containerElement that MUST have the "u-slider" css class (i.e. it can be a "<ul>" that contains "<li>" elements)
 * @returns {Function} the unsubscriber
 */
export const slider = (containerElement) => {
  let isDown = false;
  let startX;
  let scrollLeft;
  let timeout;

  const onEnd = () => {
    isDown = false;
    containerElement.classList.remove('active');
    clearTimeout(timeout);
  };

  const onStart = (e) => {
    e.preventDefault();
    isDown = true;
    timeout = setTimeout(() => {
      containerElement.classList.add('active');
    }, 250);
    startX = e.pageX || e.touches[0].pageX - containerElement.offsetLeft;
    scrollLeft = containerElement.scrollLeft;
  };

  const onMove = (e) => {
    if (!isDown) {
      return;
    }

    e.preventDefault();
    const x = e.pageX || e.touches[0].pageX - containerElement.offsetLeft;
    const dist = x - startX;
    containerElement.scrollLeft = scrollLeft - dist;
  };

  const subscribe = () => {
    containerElement.addEventListener('mousedown', onStart);
    containerElement.addEventListener('mousemove', onMove);
    containerElement.addEventListener('mouseleave', onEnd);
    containerElement.addEventListener('mouseup', onEnd);
  };

  const unsubscribe = () => {
    containerElement.removeEventListener('mousedown', onStart);
    containerElement.removeEventListener('mousemove', onMove);
    containerElement.removeEventListener('mouseleave', onEnd);
    containerElement.removeEventListener('mouseup', onEnd);
  };

  subscribe();
  return unsubscribe;
};
